import { useRef, useMemo } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import * as THREE from 'three'

const FRAG = /* glsl */ `
  uniform float uTime;
  varying vec2 vUv;

  float caustic(vec2 uv, float t) {
    float c = 0.0;
    for (int i = 0; i < 3; i++) {
      float fi = float(i);
      vec2 p = uv * (2.0 + fi * 1.5) + t * 0.06 * (fi + 1.0);
      c += sin(p.x * sin(p.y + t * 0.25) + p.y * cos(p.x - t * 0.18));
    }
    return clamp(c * 0.08 + 0.04, 0.0, 0.12);
  }

  void main() {
    float c = caustic(vUv * 3.0, uTime);
    vec3 col = mix(vec3(0.30, 0.18, 0.60), vec3(0.79, 0.66, 0.30), c * 4.0);
    gl_FragColor = vec4(col * c * 1.5, c * 0.6);
  }
`

const VERT = /* glsl */ `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`

export default function CausticPlane() {
  const matRef = useRef<THREE.ShaderMaterial>(null)
  const { viewport } = useThree()

  const uniforms = useMemo(() => ({ uTime: { value: 0 } }), [])

  useFrame(({ clock }) => {
    if (matRef.current) matRef.current.uniforms.uTime.value = clock.getElapsedTime()
  })

  return (
    <mesh position={[0, 0, -8]}>
      <planeGeometry args={[viewport.width * 2, viewport.height * 2]} />
      <shaderMaterial
        ref={matRef}
        vertexShader={VERT}
        fragmentShader={FRAG}
        uniforms={uniforms}
        transparent
        depthWrite={false}
        blending={THREE.AdditiveBlending}
      />
    </mesh>
  )
}
